var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.inited,
          expression: "inited",
        },
      ],
      staticClass: "field-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.$emit("submit")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "form-group field-form__name",
          class: {
            "is-invalid": _vm.isSubmitted && _vm.nameError,
          },
        },
        [
          _c("c-input", {
            attrs: {
              "floating-label": "Наименование поля",
              "label-full-name":
                _vm.isCopy &&
                "При изменении названия поля, оно будет обновлено во всех анкетах, в которых используется",
              "max-length": 255,
              clearable: true,
              "required-mark": true,
              required: _vm.isSubmitted && _vm.nameError,
              "required-message": _vm.isSubmitted && _vm.nameError,
            },
            model: {
              value: _vm.form.data.name,
              callback: function ($$v) {
                _vm.$set(_vm.form.data, "name", $$v)
              },
              expression: "form.data.name",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col col-12 col-lg-8" }, [
          _c(
            "div",
            { staticClass: "form-group field-form__type" },
            [
              _c("c-input", {
                attrs: {
                  type: "select",
                  label: "Тип поля",
                  "label-full-name":
                    (_vm.isCopy || _vm.blocked) &&
                    `Значение параметра «Тип поля» нельзя изменить, потому что выбранное поле используется в других анкетах`,
                  searchable: true,
                  items: _vm.fieldTypes,
                  disabled: _vm.isCopy || _vm.blocked,
                },
                model: {
                  value: _vm.form.data.fieldType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.data, "fieldType", $$v)
                  },
                  expression: "form.data.fieldType",
                },
              }),
              _vm.isFile
                ? _c("div", { staticClass: "form-note" }, [
                    _vm._v(
                      "Допустимые форматы: jpeg, jpg, png, gif, pdf, docx"
                    ),
                  ])
                : _vm._e(),
              _vm.blocked
                ? _c("div", { staticClass: "form-note" }, [
                    _vm._v(
                      " Параметр уже используется в другой анкете, поэтому изменить его нельзя "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm.hasSize
          ? _c("div", { staticClass: "col col-12 col-lg-4" }, [
              _c(
                "div",
                { staticClass: "form-group field-form__size" },
                [
                  _c("c-input", {
                    attrs: {
                      type: "select",
                      label: "Размер поля",
                      items: _vm.fieldSizes,
                    },
                    model: {
                      value: _vm.form.data.size,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.data, "size", $$v)
                      },
                      expression: "form.data.size",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "form-group checkbox" },
        [
          _c("c-checkbox", {
            attrs: {
              type: "checkbox",
              label: "Показывать в мобильном приложении",
            },
            model: {
              value: _vm.form.data.mobile,
              callback: function ($$v) {
                _vm.$set(_vm.form.data, "mobile", $$v)
              },
              expression: "form.data.mobile",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-group checkbox" },
        [
          _c("c-checkbox", {
            attrs: {
              type: "checkbox",
              label: "Доступно сотруднику для редактирования",
            },
            model: {
              value: _vm.form.data.available,
              callback: function ($$v) {
                _vm.$set(_vm.form.data, "available", $$v)
              },
              expression: "form.data.available",
            },
          }),
        ],
        1
      ),
      _vm.canBeRequired
        ? _c(
            "div",
            { staticClass: "form-group checkbox" },
            [
              _c("c-checkbox", {
                attrs: { type: "checkbox", label: "Обязательное" },
                model: {
                  value: _vm.form.data.required,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.data, "required", $$v)
                  },
                  expression: "form.data.required",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isAvailableForContract
        ? _c(
            "div",
            { staticClass: "form-group checkbox" },
            [
              _c("c-checkbox", {
                attrs: { type: "checkbox", label: "Доступно для договора" },
                model: {
                  value: _vm.form.data.contract,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.data, "contract", $$v)
                  },
                  expression: "form.data.contract",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isFile
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "form-group checkbox" },
                [
                  _c("c-checkbox", {
                    attrs: {
                      type: "checkbox",
                      label: "Ограничение по количеству загруженных файлов",
                    },
                    model: {
                      value: _vm.form.data.limitFiles,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.data, "limitFiles", $$v)
                      },
                      expression: "form.data.limitFiles",
                    },
                  }),
                ],
                1
              ),
              _c("transition", { attrs: { name: "slide" } }, [
                _vm.form.data.limitFiles
                  ? _c(
                      "div",
                      {
                        staticClass: "form-group field-form__file-count",
                        class: {
                          "is-invalid": _vm.isSubmitted && _vm.filesCountError,
                        },
                      },
                      [
                        _c("c-input", {
                          staticClass: "files-count",
                          attrs: {
                            label: "Max кол-во",
                            "label-full-name":
                              "Ограничение на количество загружаемых файлов",
                            type: "integer-number",
                            placeholder: "0",
                            required: _vm.isSubmitted && _vm.filesCountError,
                            "required-condition":
                              _vm.isSubmitted && _vm.filesCountError,
                          },
                          model: {
                            value: _vm.form.data.maxFiles,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.data, "maxFiles", $$v)
                            },
                            expression: "form.data.maxFiles",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isText
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "form-group checkbox" },
                [
                  _c("c-checkbox", {
                    attrs: { type: "checkbox", label: "Многострочное" },
                    model: {
                      value: _vm.form.data.multiline,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.data, "multiline", $$v)
                      },
                      expression: "form.data.multiline",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-group checkbox" },
                [
                  _c("c-checkbox", {
                    attrs: {
                      type: "checkbox",
                      label: "Ограничение по количеству знаков",
                    },
                    model: {
                      value: _vm.form.data.limitText,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.data, "limitText", $$v)
                      },
                      expression: "form.data.limitText",
                    },
                  }),
                ],
                1
              ),
              _c("transition", { attrs: { name: "slide" } }, [
                _vm.form.data.limitText
                  ? _c(
                      "div",
                      {
                        staticClass: "form-group field-form__text-length",
                        class: {
                          "is-invalid": _vm.isSubmitted && _vm.textLengthError,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-input-label" },
                          [
                            _vm._v(" Кол-во знаков, от — до "),
                            _c("info-button", {
                              attrs: {
                                icon: "info",
                                tooltip:
                                  "Для поля ввода можно указать минимальное и максимальное количество символов, которые можно ввести при заполнении параметра. Возможно указать только одну из значений диапазона.",
                                size: "small",
                                "no-border": "",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "text-length" },
                          [
                            _c("c-input", {
                              staticClass: "from",
                              attrs: {
                                type: "integer-number",
                                placeholder: "0",
                                required:
                                  _vm.isSubmitted && _vm.textLengthError,
                              },
                              model: {
                                value: _vm.form.data.minLength,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.data, "minLength", $$v)
                                },
                                expression: "form.data.minLength",
                              },
                            }),
                            _c("span", { staticClass: "divider" }, [
                              _vm._v("–"),
                            ]),
                            _c("c-input", {
                              staticClass: "to",
                              attrs: {
                                type: "integer-number",
                                placeholder: "0",
                                required:
                                  _vm.isSubmitted && _vm.textLengthError,
                              },
                              model: {
                                value: _vm.form.data.maxLength,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.data, "maxLength", $$v)
                                },
                                expression: "form.data.maxLength",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.isSubmitted && _vm.textLengthError
                          ? _c("error-feedback", {
                              attrs: { text: _vm.textLengthError },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isList
        ? _c("list-params", {
            attrs: {
              form: _vm.form.data,
              "field-name": _vm.form.data.name,
              "field-type": _vm.currentFieldType,
            },
            on: {
              change: function ($event) {
                _vm.inited &&
                  _vm.$emit("changeDictionary", _vm.currentFieldType)
              },
            },
          })
        : _vm._e(),
      _vm.isVariants
        ? [
            _c("field-variants", {
              staticClass: "field-variants",
              attrs: { error: _vm.isSubmitted && _vm.variantsError },
              on: {
                change: function ($event) {
                  _vm.inited &&
                    _vm.$emit("changeDictionary", _vm.currentFieldType)
                },
              },
              model: {
                value: _vm.form.data.variants,
                callback: function ($$v) {
                  _vm.$set(_vm.form.data, "variants", $$v)
                },
                expression: "form.data.variants",
              },
            }),
          ]
        : _vm._e(),
      _vm.warning
        ? _c(
            "div",
            [
              _c("error-feedback", {
                staticClass: "warning",
                attrs: { text: _vm.warningText },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }